var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Table', {
    attrs: {
      "border": "",
      "loading": _vm.tableLoading,
      "columns": _vm.filteredCol,
      "data": _vm.tableData,
      "height": _vm.tableHeight
    },
    on: {
      "on-sort-change": _vm.sortTable
    },
    scopedSlots: _vm._u([{
      key: "customer",
      fn: function (_ref) {
        var row = _ref.row;
        return [_c('Poptip', {
          attrs: {
            "title": "权责表",
            "trigger": "hover",
            "placement": "right",
            "transfer": ""
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function () {
              return [_c('div', {
                staticClass: "content-item"
              }, [_c('div', [_vm._v("开发：")]), _c('div', [_vm._v(_vm._s(row.customer.comissionDivDev.map(function (x) {
                return x.user.name + (x.ratio * 100).toFixed(0) + "%";
              }).join('、')))])]), _c('div', {
                staticClass: "content-item"
              }, [_c('div', [_vm._v("维护：")]), _c('div', [_vm._v(_vm._s(row.customer.comissionDivMaintain.map(function (x) {
                return x.user.name + (x.ratio * 100).toFixed(0) + "%";
              }).join('、')))])]), _c('div', {
                staticClass: "content-item"
              }, [_c('div', [_vm._v("回款：")]), _c('div', [_vm._v(_vm._s(row.customer.comissionDivPayment.map(function (x) {
                return x.user.name + (x.ratio * 100).toFixed(0) + "%";
              }).join('、')))])])];
            },
            proxy: true
          }], null, true)
        }, [_vm._v(" " + _vm._s(row.customer.name) + " ")])];
      }
    }, {
      key: "JDItemCode",
      fn: function (_ref2) {
        var row = _ref2.row;
        return [_c('div', [_vm._v(" " + _vm._s(row.JDItemCode ? row.JDItemCode : "-") + " ")])];
      }
    }, {
      key: "price",
      fn: function (_ref3) {
        var row = _ref3.row;
        return [_c('div', [_vm._v(" " + _vm._s(row.calcSalesCost ? _vm.adjustNumber(row, "calcSalesCost.price") : row.price ? row.price.price : "-") + " ")])];
      }
    }, {
      key: "transPrice",
      fn: function (_ref4) {
        var row = _ref4.row;
        return [_c('div', [_vm._v(" " + _vm._s(row.calcSalesCost ? _vm.adjustNumber(row, "calcSalesCost.transCost") : row.transCost ? row.transCost.cost : "-") + " ")])];
      }
    }, {
      key: "promoFee",
      fn: function (_ref5) {
        var row = _ref5.row;
        return [_c('div', [_vm._v(" " + _vm._s(row.calcSalesCost ? _vm.adjustNumber(row, "calcSalesCost.promoFee") : row.promoFeeSum ? row.promoFeeSum : "-") + " ")])];
      }
    }, {
      key: "review",
      fn: function (_ref6) {
        var row = _ref6.row;
        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "justify-content": "center"
          },
          on: {
            "click": function ($event) {
              return _vm.openReviewDrawer(row);
            }
          }
        }, [_c('TextWithCornerIcon', {
          attrs: {
            "text": "审核",
            "type": row.allowSales ? 'ok' : 'wrong'
          }
        }), row.prePaidOnly ? _c('div', [_vm._v(" - 预付 ")]) : _vm._e(), row.isLimitVolPerMonth ? _c('div', [_vm._v(" - 月限" + _vm._s(row.limitVolPerMonth) + "吨 ")]) : _vm._e()], 1)];
      }
    }, {
      key: "operate",
      fn: function (_ref7) {
        var row = _ref7.row;
        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "justify-content": "space-around",
            "align-items": "center"
          }
        }, [_c('Button', {
          attrs: {
            "type": "default",
            "size": "small"
          },
          on: {
            "click": function ($event) {
              return _vm.openCreateSalesDrawer(row);
            }
          }
        }, [_vm._v("项目")]), _c('Button', {
          attrs: {
            "type": "default",
            "size": "small"
          },
          on: {
            "click": function ($event) {
              return _vm.openSaleDrawer(row);
            }
          }
        }, [_vm._v("销售")]), _c('Dropdown', {
          attrs: {
            "trigger": "hover",
            "transfer": ""
          },
          on: {
            "on-click": _vm.clickActionDropDown
          }
        }, [_c('a', [_vm._v(" 更多 "), _c('Icon', {
          attrs: {
            "type": "ios-arrow-down"
          }
        })], 1), _c('DropdownMenu', {
          attrs: {
            "slot": "list"
          },
          slot: "list"
        }, [_c('div', [_c('DropdownItem', {
          attrs: {
            "name": `recipe ${row._id}`
          }
        }, [_vm._v(" 配方 ")]), _c('DropdownItem', {
          attrs: {
            "name": `history ${row._id}`
          }
        }, [_vm._v(" 历史 ")]), _c('DropdownItem', {
          attrs: {
            "divided": "",
            "name": `supplying ${row._id}`
          }
        }, [_vm._v(_vm._s(row.isSupplying ? "停止供货" : "供货"))])], 1)])], 1)], 1)];
      }
    }])
  }), _c('CreateSalesDrawer', {
    ref: "CreateSalesDrawer"
  }), _c('SalesCostDrawer', {
    ref: "SalesCostDrawer"
  }), _c('CalcSalesDetailDrawer', {
    ref: "CalcSalesDetailDrawer"
  }), _c('RecipeDrawer', {
    ref: "RecipeDrawer"
  }), _c('ReviewDrawer', {
    ref: "ReviewDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }